import { actions } from './actions'

const initialState = {
  urlGrupos: {
    data: [],
    loading: false,
    error: '',
  },
  urlGrupo: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function urlGruposReducer(state = initialState, action) {
  switch (action.type) {
    case actions.URL_GRUPOS_LOAD_REQUESTED:
      return { ...state, urlGrupos: { ...state.urlGrupos, loading: true } }
    case actions.URL_GRUPOS_LOAD_SUCCEEDED:
      return {
        ...state,
        urlGrupos: { ...state.urlGrupos, data: action.payload, loading: false },
      }
    case actions.URL_GRUPOS_LOAD_FILED:
      return {
        ...state,
        urlGrupos: { ...state.urlGrupos, loading: false, error: action.error },
      }
    case actions.URL_GRUPO_UPDATE_REQUESTED:
      return {
        ...state,
        urlGrupos: { ...state.urlGrupos, loading: true, error: '' },
      }
    case actions.URL_GRUPO_UPDATE_SUCCEEDED:
      return {
        ...state,
        urlGrupos: {
          ...state.urlGrupos,
          data: state.urlGrupos.data.map(url =>
            url.id === action.payload.id ? action.payload : url,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.URL_GRUPO_UPDATE_FILED:
      return {
        ...state,
        urlGrupos: { ...state.urlGrupos, loading: false, error: action.error },
      }
    case actions.URL_GRUPO_INSERT_REQUESTED:
      return {
        ...state,
        urlGrupos: { ...state.urlGrupos, loading: true, error: '' },
      }
    case actions.URL_GRUPO_INSERT_SUCCEEDED:
      return {
        ...state,
        urlGrupos: {
          ...state.urlGrupos,
          data: [].concat(action.payload, state.urlGrupos.data),
          loading: false,
          error: '',
        },
      }
    case actions.URL_GRUPO_INSERT_FILED:
      return {
        ...state,
        urlGrupos: { ...state.urlGrupos, loading: false, error: action.error },
      }
    case actions.URL_GRUPO_DELETE_REQUESTED:
      return {
        ...state,
        urlGrupos: { ...state.urlGrupos, loading: true, error: '' },
      }
    case actions.URL_GRUPO_DELETE_SUCCEEDED:
      return {
        ...state,
        urlGrupos: {
          ...state.urlGrupos,
          data: state.urlGrupos.data.filter(url => url.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.URL_GRUPO_DELETE_FILED:
      return {
        ...state,
        urlGrupos: { ...state.urlGrupos, loading: false, error: action.error },
      }
    case actions.URL_GRUPO_BYID_LOAD_REQUESTED:
      return {
        ...state,
        urlGrupo: { ...state.urlGrupo, data: null, loading: true, error: '' },
      }
    case actions.URL_GRUPO_BYID_LOAD_SUCCEEDED:
      return {
        ...state,
        urlGrupo: { ...state.urlGrupo, data: action.payload, loading: false, error: '' },
      }
    case actions.URL_GRUPO_BYID_LOAD_FILED:
      return {
        ...state,
        urlGrupo: { ...state.urlGrupo, data: null, loading: false, error: action.error },
      }
    case actions.URL_GRUPO_BYID_LOAD_INSERT_REQUESTED:
      return {
        ...state,
        urlGrupo: { ...state.urlGrupo, data: null, loading: false, error: '' },
      }
    default:
      return state
  }
}
